// All of the requested modules are loaded behind enumerable getters.
const map = Object.defineProperties({}, {
  "./_layout.tsx": { enumerable: true, get() { return require("/home/runner/work/durance-app/durance-app/src/app/_layout.tsx"); } },
  "./account.tsx": { enumerable: true, get() { return require("/home/runner/work/durance-app/durance-app/src/app/account.tsx"); } },
  "./auth/callback.tsx": { enumerable: true, get() { return require("/home/runner/work/durance-app/durance-app/src/app/auth/callback.tsx"); } },
  "./counter/[id].tsx": { enumerable: true, get() { return require("/home/runner/work/durance-app/durance-app/src/app/counter/[id].tsx"); } },
  "./counter/new.tsx": { enumerable: true, get() { return require("/home/runner/work/durance-app/durance-app/src/app/counter/new.tsx"); } },
  "./index.tsx": { enumerable: true, get() { return require("/home/runner/work/durance-app/durance-app/src/app/index.tsx"); } },
  "./reset-password.tsx": { enumerable: true, get() { return require("/home/runner/work/durance-app/durance-app/src/app/reset-password.tsx"); } },
  "./support/[id].tsx": { enumerable: true, get() { return require("/home/runner/work/durance-app/durance-app/src/app/support/[id].tsx"); } },
  "./support/index.tsx": { enumerable: true, get() { return require("/home/runner/work/durance-app/durance-app/src/app/support/index.tsx"); } },
});

function metroContext(request) {
    return map[request];
}

// Return the keys that can be resolved.
metroContext.keys = function metroContextKeys() {
  return Object.keys(map);
};

// Return the module identifier for a user request.
metroContext.resolve = function metroContextResolve(request) {
  throw new Error('Unimplemented Metro module context functionality');
}

module.exports = metroContext;